import React from 'react';
import { usePortfolioTranslation as useLocale } from 'jsx/hooks/useTranslation';

const TOP_MENU = [
  {
    id: 0,
    text: 'Viðskiptasafnið',
    // text: 'product_title_dashboard',
    url: '/',
    exact: false,
    showInNavigation: true,
  },
  {
    id: 1,
    text: 'Vöktun',
    // text: 'product_title_portfolio',
    url: '/portfolio',
    exact: false,
    showInNavigation: true,
  },
];

export default function useTopProducts() {
  const { t, locale } = useLocale();
  const products = React.useMemo(() => {
    return TOP_MENU.map((product) => ({
      ...product,
      label: t(product.text) || product.text,
      breadcrumb: t(product.text) || product.text,
    }));
  }, [t, locale]);
  return products;
}
